module.exports = __webpack_public_path__ + "img/adhibition-5.d47c2ed.png";